/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_1_Legal_LinkInputs */

const en_privacy_section_1_legal_link = /** @type {(inputs: Privacy_Section_1_Legal_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full legal and registration details`)
};

const lv_privacy_section_1_legal_link = /** @type {(inputs: Privacy_Section_1_Legal_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilni rekvizīti`)
};

/**
* | output |
* | --- |
* | "Full legal and registration details" |
*
* @param {Privacy_Section_1_Legal_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_1_legal_link = /** @type {((inputs?: Privacy_Section_1_Legal_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_1_Legal_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_1_legal_link(inputs)
	return en_privacy_section_1_legal_link(inputs)
});